/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { LockCircledIcon } from '@coursera/cds-icons';

const styles = {
  icon: css`
    circle {
      fill: var(--cds-color-blue-700);
    }
  `,
};
type Props = {
  size?: number;
  title?: string;
};

const PremiumLockIcon = (props: Props) => {
  const { size = 16, title = 'Premium' } = props;

  return (
    <LockCircledIcon
      css={styles.icon}
      style={{ width: size, height: size }}
      title={title}
      color="invert"
      data-testid="premium-lock-icon"
    />
  );
};

export default PremiumLockIcon;
